import { render, staticRenderFns } from "./OptionsList.vue?vue&type=template&id=ca4540ba&scoped=true&"
import script from "./OptionsList.vue?vue&type=script&lang=js&"
export * from "./OptionsList.vue?vue&type=script&lang=js&"
import style0 from "./OptionsList.vue?vue&type=style&index=0&id=ca4540ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4540ba",
  null
  
)

export default component.exports